"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _CORSConfiguration_1 = require("./_CORSConfiguration");
exports.PutBucketCorsInput = {
    type: "structure",
    required: ["Bucket", "CORSConfiguration"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        CORSConfiguration: {
            shape: _CORSConfiguration_1._CORSConfiguration,
            locationName: "CORSConfiguration",
            xmlNamespace: {
                uri: "http://s3.amazonaws.com/doc/2006-03-01/"
            }
        },
        ContentMD5: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "Content-MD5"
        }
    },
    payload: "CORSConfiguration"
};
//# sourceMappingURL=PutBucketCorsInput.js.map